import { Flex } from 'reflexbox';
import { ThemeProvider } from 'styled-components';

import { Spinner, defaultTheme } from '@treams/treams-ui';

import {
	Background,
	Element,
} from '../../../../../packages/@treams/treams-app/src/components/authentication/PublicForm';

export default function FullPageLoadingSpinner() {
	return (
		<ThemeProvider theme={defaultTheme}>
			<Background>
				<Element>
					<Flex alignItems="center" justifyContent="center" pt={3}>
						<Spinner />
					</Flex>
				</Element>
			</Background>
		</ThemeProvider>
	);
}
